interface OptionCardProps {
  badge?: string;
  label: string;
  letter?: string;
  loading?: boolean;
  onClick: () => void;
  selected?: boolean;
  sublabel?: string;
}

export function OptionCard({
  label,
  sublabel,
  badge,
  selected,
  loading,
  onClick,
  letter,
}: OptionCardProps) {
  return (
    <button
      className={`flex w-full items-start gap-3 rounded-xl border px-5 py-4 text-left transition-all ${
        selected
          ? "border-primary bg-primary/5 text-primary"
          : "border-border bg-background text-foreground hover:bg-accent"
      } ${loading && !selected ? "opacity-40" : ""} ${loading && selected ? "animate-pulse" : ""}`}
      onClick={onClick}
      type="button"
    >
      {letter && (
        <span
          className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md border font-medium text-xs ${
            selected
              ? "border-primary/40 bg-primary/10 text-primary"
              : "border-border bg-muted text-muted-foreground"
          }`}
        >
          {letter}
        </span>
      )}
      <span className="flex flex-1 flex-col gap-0.5">
        <span className="flex items-center gap-2 font-medium">
          {label}
          {badge && (
            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-amber-800 text-xs dark:bg-amber-900/30 dark:text-amber-400">
              {badge}
            </span>
          )}
        </span>
        {sublabel && (
          <span className="text-muted-foreground text-sm">{sublabel}</span>
        )}
      </span>
    </button>
  );
}
